import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

// HTTP
import PageNotFound from '@/views/http/PageNotFound'
import PageExpired from '@/views/http/PageExpired'

// PAYMENT VIEWS
import GatewayGetnet from '@/views/payment/GatewayGetnet'
import GatewayKhipu from '@/views/payment/GatewayKhipu'
import GatewayMercadopago from '@/views/payment/GatewayMercadopago'
import GatewayPaypal from '@/views/payment/GatewayPaypal'
import GatewayStripe from '@/views/payment/GatewayStripe'
import GatewayTwocheckout from '@/views/payment/GatewayTwocheckout'
import GatewayWebpay from '@/views/payment/GatewayWebpay'
import PaymentError from '@/views/payment/PaymentError'
import PaymentRetrieve from '@/views/payment/PaymentRetrieve'

// SOURCE VIEWS
import SourceStore from '@/views/source/SourceStore'
import SourceAdd from '@/views/source/SourceAdd'
import SourceStoreSuccess from '@/views/source/SourceStoreSuccess'
import SourceStoreError from '@/views/source/SourceStoreError'

// HOSTED VIEWS
import HostedCustomerBase from '@/views/hosted/CustomerBase'
import HostedPaymentLink from '@/views/hosted/PaymentLink'
import HostedSignupForm from '@/views/hosted/SignupForm'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/payments/:id/getnet',
      name: 'GatewayGetnet',
      component: GatewayGetnet
    },
    {
      path: '/payments/:id/khipu',
      name: 'GatewayKhipu',
      component: GatewayKhipu
    },
    {
      path: '/payments/:id/mercadopago',
      name: 'GatewayMercadopago',
      component: GatewayMercadopago
    },
    {
      path: '/payments/:id/paypal',
      name: 'GatewayPaypal',
      component: GatewayPaypal
    },
    {
      path: '/payments/:id/stripe',
      name: 'GatewayStripe',
      component: GatewayStripe
    },
    {
      path: '/payments/:id/twocheckout',
      name: 'GatewayTwocheckout',
      component: GatewayTwocheckout
    },
    {
      path: '/payments/:id/webpay',
      name: 'GatewayWebpay',
      component: GatewayWebpay
    },
    {
      path: '/payments/:id',
      name: 'PaymentRetrieve',
      component: PaymentRetrieve
    },
    {
      path: '/payments/:id/error',
      name: 'PaymentError',
      component: PaymentError
    },
    {
      path: '/sources/add/:token',
      name: 'SourceAdd',
      component: SourceAdd
    },
    {
      path: '/sources/store/success',
      name: 'SourceStoreSuccess',
      component: SourceStoreSuccess
    },
    {
      path: '/sources/store/error',
      name: 'SourceStoreError',
      component: SourceStoreError
    },
    {
      path: '/sources/:id',
      name: 'SourceStore',
      component: SourceStore
    },
    {
      path: '/hosted/customer_base/:publishableKey',
      name: 'HostedCustomerBaseAuth',
      component: HostedCustomerBase
    },
    {
      path: '/hosted/customer_base/:publishableKey/:sessionKey',
      name: 'HostedCustomerBase',
      component: HostedCustomerBase
    },
    {
      path: '/hosted/links/:publishableKey',
      name: 'HostedPaymentLink',
      component: HostedPaymentLink
    },
    {
      path: '/hosted/signup_forms/:publishableKey',
      name: 'HostedSignupForm',
      component: HostedSignupForm
    },
    {
      path: '/',
      name: 'Home',
      component: PageNotFound
    },
    {
      path: '/expired',
      name: 'PageExpired',
      component: PageExpired
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('global/CANCEL_PENDING_REQUESTS')
  next()
})

export default router
